export function safeAgentHandoffs(result: unknown): string[] {
    const links = new Set<string>();
    const visit = (value: unknown) => {
        if (!value || typeof value !== 'object')
            return;
        if (Array.isArray(value)) {
            value.forEach(visit);
            return;
        }
        const record = value as Record<string, unknown>;
        if (record.delivered === false && typeof record.deepLink === 'string') {
            try {
                const url = new URL(record.deepLink);
                if (['https:', 'http:'].includes(url.protocol) && ['wa.me', 'api.whatsapp.com'].includes(url.hostname) && !url.username && !url.password)
                    links.add(url.href);
            }
            catch { /* No untrusted URL in the UI. */ }
        }
        Object.values(record).forEach(visit);
    };
    visit(result);
    return [...links];
}
const businessFields = new Set(['title','name','number','currency','totals','total','subtotal','vat','quantity','unitPrice','phone','email','status','items','description','dueAt','notes','count','channels','quote','document','customer','reminder','folder','signers','deliveries','sent','failed','moved','skipped','results','targets','channel','to','delivery','body','amount','customerName','customerEmail','customerPhone','customerCity','installments','maxInstallments','expiresInDays','locale']);
export const visibleAgentBusinessFields = (record: Record<string,unknown>) => Object.entries(record).filter(([key])=>businessFields.has(key));

export function agentResultTarget(operation:string,id:string):string|null {
  const encoded=encodeURIComponent(id);
  return operation.startsWith('quote.') ? `/quotes/${encoded}` : operation.startsWith('signature.') ? `/quotes?open=${encoded}` : operation.startsWith('customerPayment.') ? `/customer-payments?open=${encoded}` : operation.startsWith('reminder.') ? '/reminders' : operation.startsWith('invoiceFolder.') ? `/invoices?folderId=${encoded}` : operation.startsWith('inquiry.') ? '/inquiries' : null;
}
